<template>
  <main class="main py-3 px-1 mx-auto box-border overflow-auto" :class="isMobileDevice||isTabletDevice?'w-full':''">
    <div v-if="rlsAuth">
      <div class="m-1">
        <!-- メニュー -->
        <PrimaryButton text="メニューへ" size="sm" class="bg-green-700 inline-block mr-2" @click="$router.push({ name: 'Launcher' })" :buttonContents="'要'" :disabled="loading">
        </PrimaryButton>
        <!-- 予定完了一覧 -->
        <PrimaryButton text="予定・完了一覧へ" size="sm" class="bg-green-700 inline-block ml-2" @click="$router.push({ name: 'RlsOperation' })" :buttonContents="'要'" :disabled="loading">
        </PrimaryButton>
      </div>
      <div class="my-2 flex flex-wrap justify-between">
        <div class="font-bold text-xs mr-3 w-fit my-auto">
          地図上のピン、もしくは表の「完了にする」をタップしてください。

          <div class="text-xs mt-1 font-bold text-red-700">押し忘れた場合、現地に戻る必要があります。押し忘れにご注意ください。</div>
        </div>

        <div class="mr-2 text-xs font-bold ml-auto w-fit">
          最終更新 {{ mapTimes }}
          <!-- ボタン: 地図再取得 -->
          <div>
            <PrimaryButton text="地図再描画" @click="refreshMap" :buttonContents="'要'" :disabled="loading">
              <LoadingIcon v-if="loading" slot="before" class="h-5 w-5 mr-1" />
            </PrimaryButton>
          </div>
        </div>
      </div>

      <!-- 予定 -->
      <div class="">
        <div class="p-2 w-full text-white bg-teal-600 font-bold cursol-pointer ">

          <div class="bg-teal-600">
            <!-- <div class="text-white text-xs">※担当者未定は常に表示しています。</div> -->
            <!-- 検索入力欄 -->
            <div class="flex flex-wrap py-1 px-1 min-w-300px">
              <!-- 状態 -->
              <div class="mr-2 mb-2">
                <select
                  name="status"
                  v-model="filter.status"
                  class="border-gray-300 rounded py-1.5 text-black font-bold"
                  :class="filterStatusColor()"
                  @change="refreshMap()"
                >
                  <option
                    v-for="(o, i) in statusList" :key="'s' + i"
                    :value="o.id">
                    {{ o.name }}
                  </option>
                </select>
              </div>

              <!-- 物件名 -->
              <div class="mr-2 mb-2">
                <input
                  type="search"
                  autocomplete="off"
                  name="filterSite"
                  placeholder="物件名 検索"
                  class="w-full  border border-gray-300 rounded text-black p-1.5"
                  :class="filter.site?'yellow font-bold':''"
                  v-model="filter.site"
                  @change="refreshMap"
                />
              </div>

              <!-- 担当者 -->
              <div class="mb-2 max-w-200px">
                <WmsSuggestInput
                  name="filterStaff"
                  placeholder="スタッフ 検索"
                  :selectionItems="staffList"
                  displayField="userName"
                  :embed="true"
                  :clearable="true"
                  class="font-bold"
                  :class="filter.staff?'bg-yellow':''"
                  v-model="filter.staff"
                  @selected="selectedStaff($event)"
                >
                </WmsSuggestInput>
              </div>
              <div class="ml-auto w-fit">
                <PrimaryButton :text="loading?'':'検索'" @click="refreshMap" :buttonContents="'要'" :disabled="loading" class="border border-white bg-blue-200 text-blue-800">
                  <LoadingIcon v-if="loading" slot="before" class="h-5 w-5 mr-1 text-blue-600" />
                </PrimaryButton>
              </div>
            </div>
          </div>

          <div class="mt-3" @click="openSchedule=!openSchedule">今日の予定
            <span class="pl-2 pt-2 text-xs" v-if="openSchedule">▼ ▼ ▼</span><span class="pl-2 text-xs" v-else>▶ ▶ ▶</span>
          </div>
        </div>

        <div class="accordion" :class="openSchedule?'open':''">
          <!-- 一覧 -->
          <div v-if="list && list.length" class="list border border-gray-300 text-sm overflow-auto">
            <div v-for="row in list" :key="row.id" class="border-b border-gray-400">
              <div class="items-center px-1 py-2">
                <div class="w-full">
                  <div class="flex flex-wrap items-center">
                    <!-- 物件名 -->
                    <div class="whitespace-nowrap font-bold text-gray-800 flex-1">{{row.site}}</div>
                    <!-- 住所 -->
                    <div class="whitespace-nowrap ml-3 text-gray-700 flex-1 text-xs">{{row.address || '*住所なし*'}}</div>
                  </div>

                  <div class="flex flex-wrap">
                    <div class="flex flex-wrap items-center mt-1 text-green-700 flex-1">
                      <div>（ゴ ミ）</div>
                      <!-- ゴミなし -->
                      <div v-if="!row.isTrash" class="font-bold text-lg text-gray-700">---</div>
                      <!-- ゴミあり -->
                      <div v-else class="flex">
                        <div class="self-center">{{ row.trashStaff }}</div>
                        <Icon v-if="row.trashDoneTime" iconName="CheckCircle" class="text-green-500 w-6 h-6 ml-2" />
                        <div v-else class="ml-2 p-1 text-xs font-bold text-white rounded-md bg-red-700">未</div>
                      </div>
                    </div>

                    <div class="flex flex-wrap items-center text-purple-700 flex-1 mt-1 ml-3">
                      <div>（清掃）</div>
                      <!-- 清掃なし -->
                      <div v-if="!row.isClean" class="font-bold text-lg text-gray-700">---</div>
                      <!-- 清掃あり -->
                      <div v-else class="flex">
                        <div class="self-center">{{ row.cleanStaff }}</div>
                        <Icon v-if="row.cleanDoneTime" iconName="CheckCircle" class="text-purple-500 w-6 h-6 ml-2" />
                        <div v-else class="ml-2 p-1 text-xs font-bold text-white rounded-md bg-red-700">未</div>
                      </div>
                    </div>

                    <div v-if="(row.isTrash)||(row.isClean)" class="text-blue-700 border-b border-blue-700 font-bold mt-auto w-fit px-3 pt-2 pb-1 text-center" @click="clickOpen(row)">
                      完了にする

                      <div v-if="row.report" class="text-xs">
                        ＊報告書済み
                      </div>
                      <div v-else-if="row.isReport" class="text-xs">
                        ＊報告書作成
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <p class="text-gray-400 font-bold text-center py-5 border border-gray-300">対象データがありません</p>
          </div>
        </div>
      </div>

      <!-- MAP -->
      <div id="map" ref="map" style="width: 100%; height: 500px;"></div>
    </div>
    <div v-else>
      <div class="text-gray-500 font-bold text-center py-5 border border-gray-300">RLSの権限がありません。</div>
    </div>

    <!-- 物件クリックモーダル -->
    <ClickedSiteModal
      v-model="openModal"
      :open="openModal"
      :target="modalData"
      @closed="closed"
      @refreshMap="refreshMap"
    />
  </main>
</template>

<script>
import Icon from '@components/Icon.vue'
import ClickedSiteModal from '../components/ClickedSiteModal.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import LoadingIcon from '@assets/loading-circle.svg'
import WmsSuggestInput from '@wmscomponents/WmsSuggestInput.vue'
import * as utils from '@libs/utils'
import * as backend from '@libs/backend'
import * as moment from 'moment'

import PageModel from '../../main/pages/PageModel.vue'

const SETTION_STRAGE_NAME = 'rlsForm'
const SETTION_STRAGE_NAME_myLatLng = 'rlsMyLatLng'
const SETTION_STRAGE_NAME_staffList = 'rlsStaffList'

const ERR_MSG = '位置情報取得失敗\r\n電波があるか、GPSがONになっているか、シークレットモードではないかご確認ください。'

export default {
  extends: PageModel,
  components: {
    Icon,
    ClickedSiteModal,
    PrimaryButton,
    LoadingIcon,
    WmsSuggestInput
  },

  data() {
    return {
      // ローディング
      loading: false,

      // MAP
      map: null,
      // MAPピン
      markers: [],
      // 自分のピン
      myMarker: null,
      // 物件リスト
      list: [],
      // 自動地図描画
      autoUpdateInterval: null,
      // 地図最終読み込み時間
      mapTimes: '',

      // 予定を開く
      openSchedule: false,
       //検索保持用
      filter: {
        status: 1,
        site : '',
        staff: ''
      },
      // 完了・未完了リスト
      statusList: [
        { id: 1, name: '未完了' },
        { id: 2, name: '完了' },
        { id: 0, name: '全て' },
      ],
      // スタッフリスト
      staffList: [],
      // モーダル
      openModal: false,
      modalData: null,

      // タイマー
      autoUpdateTimer: null
    }
  },

  async created() {
    // 検索条件の担当者初期値はログインユーザー
    this.filter.staff = this.user
    // 条件取得
    const strage = this.getCondition(SETTION_STRAGE_NAME)
    if (strage && Object(strage).length) {
      this.filter = strage
    }
    // スタッフリスト取得
    this.getStaff()
  },

  async mounted() {
    // 初期データ取得
    await this.getData()
    this.initMap()
    document.addEventListener('visibilitychange', this.handleVisibility)
  },

  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibility)
    if (this.autoUpdateTimer) clearTimeout(this.autoUpdateTimer)
  },

  computed: {
    /**
     * ログインユーザー名（フリガナ無し）
     */
    user() {
      return utils.deleteKana(this.$store.getters.user.user_name)
    },

    /**
     * スマホ
     */
    isMobileDevice() {
      return utils.deviceInfo.isMobile
    },

    /**
     * タブレット
     */
    isTabletDevice() {
      return utils.deviceInfo.isTablet
    },

    /**
     * RLS権限無し
     */
    rlsAuth() {
      const res = this.$store.getters.auth
      if (res && res.rlsAuth) {
        return res.rlsAuth
      } else {
        return false
      }
    },
  },

  methods: {
    /**
     * タブ非表示は止める
     */
    handleVisibility() {
      if (document.hidden) {
        clearTimeout(this.autoUpdateTimer)
      } else {
        this.scheduleAutoUpdate()
      }
    },

    /**
     * MAP初期設定
     */
    initMap() {
      // アポロ管財のビル
      let lat = 35.62428411048763
      let lng = 139.57938708329655

      // 前回の位置情報
      const myLatLng = JSON.parse(sessionStorage.getItem(SETTION_STRAGE_NAME_myLatLng))
      if (myLatLng) {
        lat = myLatLng.lat
        lng = myLatLng.lng
      }

      // 現在位置を取得
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          pos => {
            const myLatLng = {
              lat: pos.coords.latitude,
              lng: pos.coords.longitude,
            }
            this.createMap(myLatLng)
            sessionStorage.setItem(SETTION_STRAGE_NAME_myLatLng, JSON.stringify(myLatLng))
          },
          () => {
            alert(ERR_MSG)

            this.createMap({ lat, lng })
          },
          { enableHighAccuracy: true } // 高精度モード
        )
      } else {
        alert(ERR_MSG)
        this.createMap({ lat, lng });
      }
    },

    /**
     * MAP生成
     */
    async createMap(center) {
      // 地図初期化
      this.map = new google.maps.Map(this.$refs.map, {
        center,
        zoom: 17,
        styles: [
          {
            featureType: 'poi',  // ← 公園・店・学校など
            elementType: 'labels', // ← ラベルを対象
            stylers: [{ visibility: 'off' }] // ← 非表示に
          },
          {
            featureType: 'transit', // ← 駅なども消す
            stylers: [{ visibility: 'off' }]
          }
        ]
      });

      // 自分の位置マーカー
      this.myMarker = new google.maps.Marker({
        position: center,
        map: this.map,
        icon: {
          url: "/images/user.png",   // 人のアイコン画像（PNG/SVG）
          scaledSize: new google.maps.Size(40, 40), // サイズ調整
          anchor: new google.maps.Point(20, 40), // アイコンの底が座標に重なるよう調整
        },
        zIndex: -1,
      });

      // 初期描画
      this.updateMarkers()

      // 範囲変更時にマーカーを更新
      this.map.addListener('bounds_changed', () => {
        this.updateMarkers()
      })

      // 初回の自動更新予約
      this.scheduleAutoUpdate()
    },

    /**
     * マーカー描画（画面内のみ）
     */
    updateMarkers() {
      if (!this.map) return;

      const bounds = this.map.getBounds();
      if (!bounds) return;

      // 既存マーカーを削除
      this.markers.forEach(m => m.setMap(null))
      this.markers = []

      // 表示範囲内のみ描画
      this.list.forEach(p => {
        if (p.lat && p.lng) {
          const latLng = new google.maps.LatLng(Number(p.lat), Number(p.lng))
          if (bounds.contains(latLng)) {
            const marker = new google.maps.Marker({
              position: latLng,
              map: this.map,
              label: {
                text: p.site,
                color: '#0000FF',
                fontSize: '13px',
                fontWeight: 'bold'
              },
              icon: {
                url: '/images/pink.png',
              },
              row: p
            })
            this.markers.push(marker)

            marker.addListener('click', () => {
              this.clickOpen(marker.row)
            })
          }
        }
      })
    },

    /**
     * 自分の位置を更新
     */
    updateMyPosition() {
      if (!navigator.geolocation) {
        alert(ERR_MSG)
        return
      }

      navigator.geolocation.getCurrentPosition(
        pos => {
          const latLng = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude)
          this.myMarker.setPosition(latLng)

          // 自分の位置をセンターに
          this.map.setCenter(latLng)
        },
        () => alert(ERR_MSG),
        { enableHighAccuracy: true } // 高精度モード
      )
    },

    // ボタンで地図再取得
    async refreshMap() {
      // モーダル開いているときは更新しない
      if (this.openModal) {
        return
      }
      await this.getData()
      this.updateMyPosition()
      this.updateMarkers()

      // 最後の更新時刻から3分後に再予約
      this.scheduleAutoUpdate()
    },

    /**
     * スタッフリスト取得
     */
    async getStaff() {
      const strage = this.getCondition(SETTION_STRAGE_NAME_staffList)
      if (strage && strage.length) {
        this.staffList = strage
      }

      if (!this.staffList || !this.staffList.length) {
        const res = await backend.searchData('user/getByAuth', { auth: 'rls', departmentName: 'ラウンド', departmentName2: '品質管理', departmentName3: '建物管理' })
        if (res && res.data.data && res.data.data.length) {
          this.staffList = res.data.data
          this.setSessionStorage(SETTION_STRAGE_NAME_staffList, this.staffList)
        }
      }
    },

    /**
     * 予定データ取得
     */
    async getData() {
      this.loading = true
      this.setSessionStorage(SETTION_STRAGE_NAME, this.filter)
      const res = await backend.postData('rls/getSchedule', { ...this.filter, title: 'rlsForm', startDate: moment().format('YYYY-MM-DD') })
      if (res.data && res.data.data.length) {
        this.list = utils.clone(res.data.data)
      } else {
        this.list = []
      }
      this.mapTimes = moment().format('H:mm')
      this.loading = false
    },

    /**
     * 検索欄に文字が入力されていたら目立つように黄色にする
     */
    filterStatusColor() {
      if (this.filter.status == 0) {
        return ''
      }
      return 'yellow'
    },

    /**
     * 検索条件をセッションストレージへ保存
     */
    setSessionStorage(name, target) {
      const searchStr = JSON.stringify(target)
      sessionStorage.setItem(name, searchStr)
    },

    /**
     * モーダル開く
     */
    clickOpen(row) {
      this.modalData = row
      this.openModal = true
      // MAP更新ストップ
      if (this.autoUpdateTimer) {
        clearTimeout(this.autoUpdateTimer)
        this.autoUpdateTimer = null
      }
    },

    /**
     * ダイアログ閉じる
     */
    closed(isNotUpdate) {
      this.openModal = false
      if (isNotUpdate) {
        return
      }
      this.refreshMap()
    },

    /**
     *  条件取得
     */
    getCondition(name) {
      const searchJson = sessionStorage.getItem(name)
      return JSON.parse(searchJson)
    },

    /**
     * スタッフ選択
     */
    selectedStaff(e) {
      this.filter.staff = e.userName
      this.refreshMap()
    },

    /**
     * タイマー更新
     */
    scheduleAutoUpdate() {
      // 既存タイマーを解除
      if (this.autoUpdateTimer) {
        clearTimeout(this.autoUpdateTimer)
      }

      // 3分後に更新
      this.autoUpdateTimer = setTimeout(() => {
        if (this.openModal) return
        this.refreshMap()
      }, 180000) // 3分
    }

  },
}
</script>
<style scoped>

.main {
  width: 750px;
}

.accordion {
  margin: 0;
  max-height: 0;
  overflow: hidden;
  /* transition: all .5s; */
}

.open {
  max-height: fit-content;
}

.yellow {
  background: yellow;
}

.bg-yellow >>> .v-suggest input {
  background: yellow !important;
  font-weight: bold;
}

.list {
  max-height: 400px;
}

@media screen and (max-width: 750px) {
  .main {
    width: 100% !important;
  }
}
</style>